import React from 'react';
import P from 'prop-types';
import { Link } from 'react-router-dom';
import { map } from 'lodash';

import ERROR_CODES from 'data/errorCodes';
import config from 'config';

import './GraphQLErrorMessage.scss';

const GraphQLErrorMessage = ({ errors }) => {
  // Render Backend Errors.
  // Only errors from GraphQL/LoopBack should render here.
  // We filter out non-backend/submission error messages, or else we'd double up
  // on error messages, as we already show yup/schema validation messages below each field.
  if (!Object.keys(errors).length) return null;

  return map(errors, (message, code) => {
    const isBackEndError = Object.values(ERROR_CODES).includes(code);
    if (!isBackEndError) return;

    let errorMsg = message;

    // Change error messages below if a custom error message is required.
    if (code === ERROR_CODES.EMAIL_ALREADY_EXISTS) {
      errorMsg = (
        <div>
          It looks like you are already a member of Be Collective.<br />
          Please <Link to="/login">log in</Link> or register with a different email.
        </div>
      );
    }
    else if (code === ERROR_CODES.INVALID_MIGRATION_PASSWORD) {
      errorMsg = (
        <div>
          Be Collective has recently updated our security to ensure that your information is safe.<br />
          Please <a href={`${config.WEB_URL}/login`} target="_blank" rel="noopener noreferrer">log in</a> to Be Collective to update your password.
        </div>
      );
    }
    else if (code === ERROR_CODES.CODE_MISMATCH) {
      errorMsg = 'The code you entered is incorrect. Please try again.';
    }

    return (
      <div key={code} className="GraphQLErrorMessage" >
        {errorMsg}
      </div>
    );
  });
};

GraphQLErrorMessage.propTypes = {
  errors: P.shape({
    code: P.string,
    message: P.string,
  }),
};

export default GraphQLErrorMessage;
